// extracted by mini-css-extract-plugin
module.exports = {"stocks":"stocks-C22TyRt1","caption":"caption-1F0xq3Bd","picTxt":"picTxt-1HLGdZlg","box_pic":"box_pic-2vb4XDWb clearfix"};